import type { ErrorComponentProps } from '@tanstack/react-router'
import { HostContext } from '@utils'
import Error500 from './Error500'
import { Store } from '../router/_helpers/authStore'

const authStore = new Store()

const AuthError = ({ error }: ErrorComponentProps) => {
  const errorInstance =
    error instanceof Error ? error : new Error(String(error))
  const { host } = authStore.getState()

  if (host) {
    // Use host to close the window with CloseButton
    return (
      <HostContext.Provider value={host}>
        <Error500 error={errorInstance} />
      </HostContext.Provider>
    )
  } else {
    return <Error500 error={errorInstance} />
  }
}
export default AuthError
